module.exports = __webpack_public_path__ + "static/team18-31f75952380a61ba03c73b74471c7d89.jpg";